import * as React from 'react';
import { Paragraph } from 'react-native-paper';

export function CustomParagraph(props) {
  if (!props) {
    props = {};
  }
  return (
    <Paragraph
      style={{
        paddingVertical: 5,
        ...props.style,
      }}
      selectable={true}
      { ...props }
    />
  );
}
